
  // 确保DOM完全加载完毕
  document.addEventListener('DOMContentLoaded', function() {
      // 使用scrollIntoView方法滚动到指定的section
      
      const dom  = document.querySelector('.drawcontainer.is-section');
      let visible = false;
        let timer = setInterval(() => {
           visible = $('.drawcontainer.is-section').is(':visible');

           if(visible){
            dom.scrollIntoView({
                block: 'center',
                behavior: 'smooth' // 平滑滚动
            }); 
            clearInterval(timer);
            timer = null;
           }
        }, 500);   
  });
